import { ReduxDispatch } from "models/ReduxProps";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import IntegrationEffect, { ISearchAnagCqCrmRequest } from "./IntegrationEffects";
import IntegrationModel from "./models/IntegrationModel";
import SearchAnagCqCrmModel from "./models/SearchAnagCqCrmModel";
import ResultModel from "./models/ResultModel";

type ActionUnion = undefined | HttpErrorResponseModel | IntegrationModel | SearchAnagCqCrmModel | ResultModel;

export default class IntegrationAction {
    public static readonly REQUEST_INTEGRATION: string = "IntegrationAction.REQUEST_INTEGRATION";
    public static readonly REQUEST_INTEGRATION_FINISHED: string = "IntegrationAction.REQUEST_INTEGRATION_FINISHED";

    public static readonly REQUEST_SEARCH_ANAG_CQCRM: string = "IntegrationAction.REQUEST_SEARCH_ANAG_CQCRM";
    public static readonly REQUEST_SEARCH_ANAG_CQCRM_FINISHED: string =
        "IntegrationAction.REQUEST_SEARCH_ANAG_CQCRM_FINISHED";

    public static readonly REQUEST_SEARCH_ANAG_CQCRM_OUT_VISIBILITY: string =
        "IntegrationAction.REQUEST_SEARCH_ANAG_CQCRM_OUT_VISIBILITY";
    public static readonly REQUEST_SEARCH_ANAG_CQCRM_OUT_VISIBILITY_FINISHED: string =
        "IntegrationAction.REQUEST_SEARCH_ANAG_CQCRM_OUT_VISIBILITY_FINISHED";

    public static integration(totp: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<IntegrationModel>(
                dispatch,
                IntegrationAction.REQUEST_INTEGRATION,
                IntegrationEffect.integration,
                totp
            );
        };
    }

    public static searchAnagCqCrm(request: ISearchAnagCqCrmRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<SearchAnagCqCrmModel>(
                dispatch,
                IntegrationAction.REQUEST_SEARCH_ANAG_CQCRM,
                IntegrationEffect.searchAnagCqCrm,
                request
            );
        };
    }

    public static existsAnagCqCrmOutVisibility(request: ISearchAnagCqCrmRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<ResultModel>(
                dispatch,
                IntegrationAction.REQUEST_SEARCH_ANAG_CQCRM_OUT_VISIBILITY,
                IntegrationEffect.existsAnagCqCrmOutVisibility,
                request
            );
        };
    }

    public static setSelectedAnag(form: SearchAnagCqCrmModel): any {
        return ActionUtility.createAction(IntegrationAction.REQUEST_SEARCH_ANAG_CQCRM_FINISHED, form);
    }
}
